import * as React from 'react';

export interface DividerProps {
  size?: 'large' | 'small' | 'medium' | 'x-small';
  vertical?: boolean;
}


export interface DividerState {
}

export default class Divider extends React.Component<DividerProps, DividerState> {
  constructor(props: DividerProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      <hr className={"divider " + (this.props.size || 'large') + (this.props.vertical? ' divider-vertical':'')}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/divider.tsx